import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: {
        backgroundColor: 'white',
        fontFamily: "Roboto",
        width: '95%',
        margin: '0 auto',
    },
    topColumn: {
        width: '100%',
        height: '10%',
        backgroundColor: '#39673f',
        display: 'flex',
        flexDirection: 'row',
    },
    bottomColumns: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
    },
    headers_container: {
        width: '100%',
        height: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
    },
    headers: {
        flexBasis: '100%',
        color: 'white',
        fontSize: '8px',
        width: '100%',
        textAlign: 'center',
        padding: '2px',
    },
    mainHeader: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: 30,
        textAlign: 'center',
        margin: 10,
    },
    mainSubHeader: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: 20,
        textAlign: 'center',
        margin: 5,
    },
    cells_container: {
        marginTop: '4px',
        marginBottom: '4px',
        paddingTop: '5px',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        minHeight: '35px',
        maxHeight: '35px',
    },
    cell: {
        flexBasis: '100%',
        fontSize: '8px',
        textAlign: 'center',
        paddingRight: '2px',
        paddingLeft: '2px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflowWrap: 'break-word',
    },
    logo: {
        height: '100%',
        imageRendering: 'crisp-edges',
    },
    container: {
        padding: '12px',
        paddingTop: '0px',
        width: '100%',
    },
    header: {
        width: '100%',
        height: '50px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        fontSize: '18px',
        textAlign: 'center',
    },
    familyBox: {
        marginTop: "15px",
        marginBottom: '15px',
        padding: '12px 16px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
        fontSize: '16',
        color: '#333',
        fontWeight: 'normal',
        lineHeight: '1.4',
        width: 'auto',
        boxSizing: 'border-box',
    },
    ownerContainer: {
        width: '70%',
        margin: '5%',
        borderRadius: '4px',
        border: '1px solid black',
        fontSize: '8px',
        backgroundColor: 'white',
    },
    ownerContainerCell: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        borderBottom: '1px solid black',
        alignItems: 'center',
    },
    ownerContainerHeaderText: {
        width: '50%',
        padding: '5px',
        display: 'flex',
        justifyContent: 'center',
    },
    ownerContainerCellText: {
        width: '50%',
        height: '100%',
        padding: '5px',
        fontSize: '7px',
        borderLeft: '1px solid black',
        display: 'flex',
        justifyContent: 'center',
    },
    sheepContainer: {
        width: '80%',
        margin: '2%',
        borderRadius: '4px',
        border: '1px solid black',
        fontSize: '8px',
        backgroundColor: 'white',
    },
    sheepHeader: {
        borderBottom: '1px solid black',
        fontSize: '8px',
        fontStyle: 'medium',
        padding: '6px',
    },
    sheepContainerCell: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    sheepContainerHeaderText: {
        width: '50%',
        padding: '3px',
        display: 'flex',
        justifyContent: 'center',
    },
    sheepContainerCellText: {
        width: '50%',
        height: '100%',
        padding: '3px',
        fontSize: '7px',
        display: 'flex',
        justifyContent: 'center',
    },
    daughterCard: {
        marginBottom: '20px',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        backgroundColor: '#fff',
    },
    daughterHeader: {
        fontSize: '12px',
        marginBottom: '5px',
    },
    milkDataContainer: {
        marginTop: '10px',
    },
    milkRecording: {
        marginTop: '5px',
    },

    /* --- Sister Tables --- */
    sistersContainer: {
        width: '90%',
        marginTop: '10px',
    },
    sisterCategory: {
        marginBottom: '10px',
    },
    sisterHeader: {
        fontSize: '8px',  // Reduced font size for sister header
        textDecoration: 'underline',
        marginBottom: '5px',
    },

    sisterTable: {
        marginTop: 10,
        borderWidth: 1,
        borderColor: '#000',
    },
    sisterTableHeader: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#000',
        backgroundColor: '#f2f2f2',
    },
    sisterRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#ddd',
        fontSize: 9,
    },
    sisterCell: {
        flex: 1,
        padding: 5,
        textAlign: 'center',
        borderRightWidth: 1,
        borderRightColor: '#ddd',
        fontSize: 7,
    },
    subheading: {
        fontSize: 9,
        marginBottom: 5,
    },

    lastCell: {
        flex: 1,
        padding: '3px',
    },
    sonCategory: {
        marginTop: 20,
        padding: 10,
        borderTopWidth: 2,
        borderTopColor: '#000',
        backgroundColor: '#f9f9f9',
    },

    sonItem: {
        marginBottom: 10,
        padding: 8,
        borderWidth: 1,
        borderColor: '#ddd',
        borderRadius: 5,
        backgroundColor: '#fff',
    },

    sonText: {
        fontSize: 10,
        marginBottom: 4,
    },
    siblingsCategory: {
        marginTop: 20,
        padding: 10,
        borderTopWidth: 2,
        borderTopColor: '#000',
        backgroundColor: '#f9f9f9',
    },

    siblingItem: {
        marginBottom: 10,
        padding: 8,
        borderWidth: 1,
        borderColor: '#ddd',
        borderRadius: 5,
        backgroundColor: '#fff',
    },

    siblingText: {
        fontSize: 10,
        marginBottom: 4,
    },
    row: {
        flexDirection: 'row',
        marginBottom: 10,
        justifyContent: 'space-between',
    },
    table: {
        display: 'table',
        width: '100%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#000',
    },
    tableColHeader: {
        width: '16.6%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#000',
        backgroundColor: '#ddd',
        padding: 5,
        fontSize: 10,
        textAlign: 'center',
    },
    tableCol: {
        width: '16.6%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#000',
        padding: 5,
        fontSize: 10,
        textAlign: 'center',
    },
    animalInfoContainer: {
        padding: 15,
        backgroundColor: '#f8f8f8',
        borderRadius: 8,
        marginBottom: 15,
        pageBreakAfter: "always",
    },
    animalHeader: {
        marginBottom: 15,
        fontSize: 14,
    },
    titleText: {
        fontSize: 13,
        textAlign: 'center',
        marginBottom: 10,
    },
    tableRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 5,
        backgroundColor: '#ffffff',
        borderRadius: 5,
    },
    tableCellHeader: {
        flex: 1,
        borderWidth: 1,
        borderColor: '#ddd',
        padding: 3,
        fontSize: 10,
        textAlign: 'center',
        backgroundColor: '#e0e0e0',
    },
    tableCell: {
        flex: 1,
        borderWidth: 1,
        borderColor: '#ddd',
        padding: 8,
        fontSize: 8,
        textAlign: 'center',
        backgroundColor: '#fff',
    },
});

export default styles;
